import httpClient from '@/http-client'

export const get = (Options = {}) => {
    return httpClient
        .get('/api/v1/reports/transection-back-dates', Options)
        .then(response => Promise.resolve(response.data))
        .catch(error => Promise.reject(error.response.data))
}

export const transectionBackDateExcel = data => {
    return httpClient
        .post('/api/v1/reports/transection-back-dates/excels', data, {
            responseType: 'arraybuffer'
        })
        .then(response => Promise.resolve(response))
        .catch(error => Promise.reject(error.response.data))
}

export default { get, transectionBackDateExcel }
